
module.exports = {
    // endpoint: "http://127.0.0.1:8077",
    endpoint: "https://lit-api.unisigns.de",
}